import React from 'react'

function Explore() {
  return (
    <>
    {/* // <div className=" bg-black/90 h-screen w-screen text-white pt-12"> */}
    <div>
<div className=" bg-black/90 text-white w-screen ">
  <div className=''>
  <div className='flex pt-[200px] justify-center w-full '>
      <div className='text-center tracking-wide font-bold gap-3 slide-up'>
      <div className='uppercase'>explore further</div>
      <div className='uppercase'>continue your journey</div>
      </div>
      </div>
      </div>
    </div>
    </div>
    </>

  )
}

export default Explore